import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import app from './store/app';
import auth from './store/auth';
import page from './store/page';
import cart from './store/cart';
import checkout from './store/checkout';
import favorite from './store/favorite';
import notify from './store/notify';

const vuexPersist = new VuexPersistence({
  key: 'nushenamel-app',
  storage: localStorage
});

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    vuexPersist.plugin
  ],
  modules: {
    app,
    auth,
    page,
    cart,
    checkout,
    favorite,
    notify
  }
});
